import React from 'react';

// Small inline nav/dropdown glyphs — replaces the raw emoji previously used
// in HomePage's tools dropdown and mobile nav. Plain geometric shapes
// (currentColor strokes/fills), sized to sit inline with nav link text.
const base = { width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none', 'aria-hidden': true };

const icons = {
  transfer: (
    <svg {...base}>
      <path d="M3 5.5h8l-2-2M13 10.5H5l2 2" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  lineup: (
    <svg {...base}>
      <rect x="2" y="2" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="8" cy="5.5" r="1.1" fill="currentColor" />
      <circle cx="5" cy="10" r="1.1" fill="currentColor" />
      <circle cx="11" cy="10" r="1.1" fill="currentColor" />
    </svg>
  ),
  tactics: (
    <svg {...base}>
      <rect x="2.5" y="2" width="11" height="12" rx="1.4" stroke="currentColor" strokeWidth="1.3" />
      <path d="M5 6h6M5 8.5h6M5 11h3.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  cup: (
    <svg {...base}>
      <path d="M5 3h6v4a3 3 0 0 1-6 0Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M5 4H3.3C3.3 6 4.3 7 5.3 7.2M11 4h1.7c0 2-1 3-2 3.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M8 10v2M6 13.5h4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  budgetsquad: (
    <svg {...base}>
      <circle cx="8" cy="8" r="5.6" stroke="currentColor" strokeWidth="1.3" />
      <path d="M8 5v6M9.6 6.3c0-.7-.7-1.2-1.6-1.2s-1.6.5-1.6 1.2c0 1.6 3.2.9 3.2 2.5 0 .7-.7 1.2-1.6 1.2s-1.6-.5-1.6-1.2" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  ),
  cycle: (
    <svg {...base}>
      <path d="M3.3 8a4.7 4.7 0 0 1 8-3.3l1 1M12.7 8a4.7 4.7 0 0 1-8 3.3l-1-1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M12.3 3.7v2h-2M3.7 12.3v-2h2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  bench: (
    <svg {...base}>
      <path d="M2.5 6.5h11M3.5 6.5v5M12.5 6.5v5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M2.5 9h11" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  ),
  rank: (
    <svg {...base}>
      <rect x="2.5" y="9" width="2.6" height="4.5" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
      <rect x="6.7" y="6" width="2.6" height="7.5" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
      <rect x="10.9" y="3" width="2.6" height="10.5" rx="0.6" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  ),
  target: (
    <svg {...base}>
      <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="8" cy="8" r="3" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="8" cy="8" r="0.9" fill="currentColor" />
    </svg>
  ),
  card: (
    <svg {...base}>
      <rect x="3.5" y="2" width="9" height="12" rx="1.4" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="6" cy="5.2" r="0.9" fill="currentColor" />
      <path d="M5.3 10.5l1.4-2 1.4 2 1.4-2 1.4 2" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  question: (
    <svg {...base}>
      <circle cx="8" cy="8" r="5.6" stroke="currentColor" strokeWidth="1.3" />
      <path d="M6.3 6.3a1.9 1.9 0 0 1 3.6.8c0 1.4-1.7 1.4-1.9 2.6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <circle cx="8" cy="11.3" r="0.7" fill="currentColor" />
    </svg>
  ),
  alphabet: (
    <svg {...base}>
      <text x="8" y="11.5" textAnchor="middle" fontSize="8.5" fontWeight="800" fill="currentColor" fontFamily="inherit">Az</text>
    </svg>
  ),
  squadbuilder: (
    <svg {...base}>
      <path d="M6.2 3.2a3 3 0 0 1 4 3.9l4.1 4.1-1.7 1.7-4.1-4.1a3 3 0 0 1-3.9-4l1.8 1.8 1.4-1.4Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  ),
  globe: (
    <svg {...base}>
      <circle cx="8" cy="8" r="5.6" stroke="currentColor" strokeWidth="1.3" />
      <path d="M2.4 8h11.2M8 2.4a8.4 8.4 0 0 1 0 11.2M8 2.4a8.4 8.4 0 0 0 0 11.2" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  ),
  home: (
    <svg {...base}>
      <path d="M2.6 7.4 8 3l5.4 4.4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 6.6V13h8V6.6" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
      <path d="M6.4 13v-3.4h3.2V13" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  ),
  share: (
    <svg {...base}>
      <circle cx="11.7" cy="3.7" r="1.6" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="11.7" cy="12.3" r="1.6" stroke="currentColor" strokeWidth="1.2" />
      <circle cx="4.3" cy="8" r="1.6" stroke="currentColor" strokeWidth="1.2" />
      <path d="M5.7 7.2 10.3 4.5M5.7 8.8l4.6 2.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
  download: (
    <svg {...base}>
      <path d="M8 2.5v7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M5 6.8 8 9.8l3-3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.8 11.5v1.7h10.4v-1.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  link: (
    <svg {...base}>
      <path d="M6.7 9.3 9.3 6.7" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M7.3 4.4 8 3.7a2.6 2.6 0 0 1 3.7 3.7l-.9.9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <path d="M8.7 11.6l-.7.7a2.6 2.6 0 0 1-3.7-3.7l.9-.9" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  info: (
    <svg {...base}>
      <circle cx="8" cy="8" r="5.6" stroke="currentColor" strokeWidth="1.3" />
      <circle cx="8" cy="5.4" r="0.9" fill="currentColor" />
      <path d="M8 7.6v3.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  ),
  bolt: (
    <svg {...base}>
      <path d="M8.6 2.4 3.8 8.8h3l-1.4 4.8 5.8-6.9h-3.2z" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
    </svg>
  ),
  mail: (
    <svg {...base}>
      <rect x="2.2" y="4" width="11.6" height="8" rx="1.3" stroke="currentColor" strokeWidth="1.3" />
      <path d="M2.7 4.6 8 8.4l5.3-3.8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  bulb: (
    <svg {...base}>
      <path d="M8 2.6a3.9 3.9 0 0 1 2.2 7.1c-.5.4-.8 1-.8 1.6v.2H6.6v-.2c0-.6-.3-1.2-.8-1.6A3.9 3.9 0 0 1 8 2.6Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M6.7 13.4h2.6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  ),
};

export function NavIcon({ id, className, size }) {
  const icon = icons[id];
  if (!icon) return null;
  const props = { className };
  if (size) {
    props.width = size;
    props.height = size;
  }
  return React.cloneElement(icon, props);
}

export default NavIcon;
